import React from "react";
import { Navigate } from "react-router-dom";
import { useAnalyticsAccess } from "../hooks/useAnalyticsAccess";
import LoadingSpinner from "../components/ui/LoadingSpinner";
import NotFoundPage from "../pages/NotFound";

interface AnalyticsProtectedRouteProps {
    children: JSX.Element;
    isLoggedIn: boolean;
}

/**
 * Protected route for Analytics:
 * - User is logged in
 * - User is Rewind owner OR company has the analytics addon
 */
const AnalyticsProtectedRoute: React.FC<AnalyticsProtectedRouteProps> = ({ children, isLoggedIn }) => {
    const { hasAccess, loading } = useAnalyticsAccess();

    if (loading) {
        return <LoadingSpinner size={50} />;
    }

    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    if (!hasAccess) {
        return <NotFoundPage />;
    }

    return children;
};

export default AnalyticsProtectedRoute;
